
import { nanoid } from "nanoid";
import { Chat, Message } from "../types";

export const createDefaultChat = (): Chat => ({
  id: nanoid(),
  userName: "No Active Chats",
  userEmail: "",
  messages: [],
  lastActivity: Date.now(),
  isActive: true,
  status: "new",
  ipAddress: "",
  country: ""
});

export const transformChatData = (chat: any, messages: Message[]): Chat => ({
  id: chat.id,
  userName: chat.user_name || "Unknown User",
  userEmail: chat.user_email || "",
  accountNumber: chat.account_number,
  messages,
  lastActivity: chat.last_activity ? new Date(chat.last_activity).getTime() : Date.now(),
  isActive: chat.is_active === true,
  status: chat.status || "new",
  assignedTo: chat.assigned_to,
  ipAddress: chat.ip_address,
  country: chat.country,
  priority_level: chat.priority_level
});
